import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { createSVGIcon } from "@faire/web--source/slate/icons/util";
import React from "react";
export var LeftStreak = createSVGIcon(/*#__PURE__*/ _jsx("svg", {
    width: "7",
    height: "7",
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "https://www.w3.org/2000/svg",
    children: /*#__PURE__*/ _jsx("path", {
        d: "M6 1C6 1 4.11317 1.80621 3 2.81818C1.88683 3.83015 1 6 1 6",
        stroke: Core.icon.default,
        strokeLinecap: "round",
        strokeWidth: 1
    })
}), "LefStreak", {
    viewBox: "0 0 32 32",
    width: "32px",
    height: "32px",
    fill: "none"
});
